import Axios from "axios";
import {
  SET_SETTINGS_INFO_LIST,
  UNSET_SETTINGS_INFO_LIST,
  SET_SETTINGS_INFO_DETAILS,
  UNSET_SETTINGS_INFO_DETAILS,
} from "@/store/mutation-types";
import {
  getSettingsInfoList,
  getSettingsInfoById,
  getSettingsInfoByEmployee,
  saveUpdateSettingsInfo,
  saveEmployeeSettingsInfo,
  updateSettingsInfo,
  deleteSettingsInfo,
  bulkDeleteSettingsInfo,
} from "@/store/api";

const state = {
  settingsInfoList: [],
  settingsInfoDetails: null,
};

const getters = {
  getSettingsInfoList(state) {
    return state.settingsInfoList;
  },
  getSettingsInfoDetails(state) {
    return state.settingsInfoDetails;
  },
};

const mutations = {
  [SET_SETTINGS_INFO_LIST](state, data) {
    state.settingsInfoList = data;
  },
  [UNSET_SETTINGS_INFO_LIST](state) {
    state.settingsInfoList = [];
  },
  [SET_SETTINGS_INFO_DETAILS](state, data) {
    state.settingsInfoDetails = data;
  },
  [UNSET_SETTINGS_INFO_DETAILS](state) {
    state.settingsInfoDetails = null;
  },
};

const actions = {
  getSettingsInfoList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(getSettingsInfoList, params)
        .then((response) => {
          commit(SET_SETTINGS_INFO_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_SETTINGS_INFO_LIST);
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getSettingsInfoById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(getSettingsInfoById(id))
        .then((response) => {
          commit(SET_SETTINGS_INFO_DETAILS, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_SETTINGS_INFO_DETAILS);
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getSettingsInfoByEmployee({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      Axios.get(getSettingsInfoByEmployee(employeeId))
        .then((response) => {
          commit(SET_SETTINGS_INFO_DETAILS, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_SETTINGS_INFO_DETAILS);
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  saveSettingsInfo({ commit }, settingsData) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSettingsInfo, settingsData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  saveEmployeeSettingsInfo({ commit }, { employeeId, settingsData }) {
    return new Promise((resolve, reject) => {
      Axios.post(saveEmployeeSettingsInfo, {
        employee_id: employeeId,
        settings_data: settingsData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  updateSettingsInfo({ commit }, { id, settingsData }) {
    return new Promise((resolve, reject) => {
      Axios.put(updateSettingsInfo(id), settingsData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  deleteSettingsInfo({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.delete(deleteSettingsInfo(id))
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  bulkDeleteSettingsInfo({ commit }, ids) {
    return new Promise((resolve, reject) => {
      Axios.post(bulkDeleteSettingsInfo, { ids })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

